import type { Condition } from '@repo/api-gw-sdk';
import { ConditionOperatorEnum } from '@repo/api-gw-sdk';

// Without grouping the editor renders nested groups borderless and without an operator, so every condition the
// user sees reads as one AND list; a new root condition must join that list, never sit beside it under an OR.
export const appendRootCondition = (
  condition: Condition,
  newCondition: Condition
): Condition =>
  condition.operator === ConditionOperatorEnum.And
    ? {
        ...condition,
        conditions: [...(condition.conditions ?? []), newCondition],
      }
    : {
        operator: ConditionOperatorEnum.And,
        conditions: [condition, newCondition],
      };
